let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("ffEVr"), load("e3Tty")]).then(() => parcelRequire('f4aeC'));